import { Card, CardContent, CardHeader, Link } from '@forgeglobal/design-framework'
import { Routes } from 'util/Routes'
import { useAccountEntitiesQuery } from 'graphql/bindings/AdminBindings'
import React, { Fragment } from 'react'
import uniqBy from 'lodash/uniqBy'

const AccountEntities = ({ accountId }: { accountId: string }) => {
  const { data } = useAccountEntitiesQuery({ variables: { id: accountId } })
  const entities = uniqBy(data?.account?.entities ?? [], 'id')

  return (
    <Card>
      <CardHeader title="Entities" />
      <CardContent>
        {entities.map((entity, i) => (
          <Fragment key={entity.id}>
            <Link href={Routes.adminEntityPage(entity.id)} target="_blank">
              <b>{entity.name}</b>
            </Link>
            {i < entities.length - 1 && <br />}
          </Fragment>
        ))}
      </CardContent>
    </Card>
  )
}

export { AccountEntities }
